import { useCallback, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { setUiDrawerClientTop } from '../../store/ui/uiSlice'
import { MINI_MAP_HEIGHT, PE_MAIN_START_POS, PE_MAIN_VALUES } from '../main/main.constants'
import { PREHEADER_HEIGHT } from '../header/header-constants'
import { isPE } from '../Device'
import { throttle } from '../../utils/function'

const useMainScroll = () => {
  const dispatch = useDispatch()
  const mainRef = useRef(null)

  const getDrawerTopPosition = () => mainRef.current?.getBoundingClientRect().top
  const triggerInitialScroll = useCallback(() => {
    if (__BROWSER__) {
      document.documentElement.scrollTo({
        top: global.window.innerHeight - MINI_MAP_HEIGHT - PREHEADER_HEIGHT - PE_MAIN_VALUES[PE_MAIN_START_POS.low],
        behavior: 'smooth'
      })
    }
  }, [])

  const updateMainTop = useCallback(() => {
    if (!mainRef.current || getComputedStyle(mainRef.current).display === 'none') return
    dispatch(setUiDrawerClientTop(getDrawerTopPosition()))
  }, [])

  const handleScroll = useCallback(() => {
    updateMainTop()
  }, [])

  const handleResize = useCallback(() => {
    setTimeout(() => {
      // the resize is fired before the navigator move the top after the address bar is hide
      updateMainTop()
    }, 200)
  }, [])

  useEffect(() => {
    if (__BROWSER__ && isPE()) {
      const throttledHandler = throttle(handleScroll, 50)
      window.addEventListener('scroll', throttledHandler)
      window.addEventListener('resize', handleResize)
      throttledHandler()

      return () => {
        window.removeEventListener('scroll', throttledHandler)
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [])

  return { mainRef, triggerInitialScroll }
}

export default useMainScroll
